"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var _CommunicatorStore = _interopRequireDefault(require("customer-data-communicator/data/communicator/stores/CommunicatorStore"));

var _NoteContentMediator = require("customer-data-communicator/schema/interactions/note/NoteContentMediator");

var dependencies = {
  initialInteraction: {
    stores: [_CommunicatorStore.default],
    deref: function deref(_ref) {
      var interaction = _ref.interaction;

      var initialContent = _CommunicatorStore.default.get('initialContent');

      if (!initialContent) {
        return _LoadingStatus.EMPTY;
      }

      var noteContent = initialContent.get(_InteractionTypes.NOTE);

      if (!noteContent) {
        return _LoadingStatus.EMPTY;
      }

      return (0, _NoteContentMediator.toNoteInteractionRecord)(interaction, noteContent);
    }
  }
};
var _default = dependencies;
exports.default = _default;
module.exports = exports.default;